/* HP - Hero #27: Descargas dinámicas (+1 a +20 por día) */
(() => {
  if (window.__hpHero27DownloadsInit) return;
  window.__hpHero27DownloadsInit = true;

  const MS_PER_DAY = 24 * 60 * 60 * 1000;

  const pad2 = (n) => String(n).padStart(2, '0');

  const toLocalISO = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

  const parseYYYYMMDD = (s) => {
    if (!s || typeof s !== 'string') return null;
    const m = s.trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return null;
    const y = Number(m[1]);
    const mo = Number(m[2]) - 1;
    const da = Number(m[3]);
    const d = new Date(y, mo, da);
    if (d.getFullYear() !== y || d.getMonth() !== mo || d.getDate() !== da) return null;
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const hash32 = (str) => {
    let h = 2166136261;
    for (let i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  };

  const rand01 = (seed) => {
    // Mulberry32
    let t = (seed + 0x6D2B79F5) >>> 0;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };

  const randInt = (seed, min, max) => {
    const r = rand01(seed);
    return Math.floor(r * (max - min + 1)) + min;
  };

  const computeDownloads = ({ start, startDate, todayDate, minInc, maxInc, seedBase }) => {
    const startNum = Number(start);
    if (!Number.isFinite(startNum)) return null;
    const sd = parseYYYYMMDD(startDate);
    if (!sd) return null;

    const today = parseYYYYMMDD(todayDate) || (() => {
      const d = new Date();
      d.setHours(0, 0, 0, 0);
      return d;
    })();

    const days = Math.max(0, Math.floor((today.getTime() - sd.getTime()) / MS_PER_DAY));

    let total = startNum;
    for (let i = 0; i < days; i++) {
      const d = new Date(sd.getTime() + i * MS_PER_DAY);
      const dayKey = toLocalISO(d);
      const seed = hash32(`${seedBase}|${dayKey}`);
      total += randInt(seed, minInc, maxInc);
    }
    return total;
  };

  const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const applyToOne = (root) => {
    if (!root || root.dataset.hpDownloadsApplied === '1') return;

    const enabled = String(root.dataset.downloadsDynamic || '').toLowerCase() === 'true';
    if (!enabled) return;

    const includePlus = root.dataset.downloadsIncludePlus !== 'false';

    const start = root.dataset.downloadsStart || '2000';
    const startDate = root.dataset.downloadsStartDate || '';
    const todayDate = root.dataset.downloadsToday || '';
    const labelRaw = (root.dataset.downloadsLabel !== undefined) ? root.dataset.downloadsLabel : 'Descargas';
    const label = String(labelRaw).trim();
    const seedBase = root.dataset.downloadsSeed || 'hp-hero27';

    const value = computeDownloads({
      start,
      startDate,
      todayDate,
      minInc: 1,
      maxInc: 20,
      seedBase,
    });
    if (value == null) return;

    const container = root.querySelector('.hp-hero27-review-text') || root;

    // Busca el texto que contiene el label (Descargas) y reemplaza el +numero (o numero) anterior.
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    const re = includePlus
      ? new RegExp(`(\\+)\\s*\\d+(?=\\s*${escapeRegExp(label)})`, 'i')
      : new RegExp(`\\d+(?=\\s*${escapeRegExp(label)})`, 'i');

    let node;
    while ((node = walker.nextNode())) {
      const t = node.nodeValue;
      if (!t || t.indexOf(label) === -1) continue;
      if (re.test(t)) {
        node.nodeValue = includePlus ? t.replace(re, `+${value}`) : t.replace(re, `${value}`);
        root.dataset.hpDownloadsApplied = '1';
        return;
      }
    }

    // Fallback: reemplaza el ÚLTIMO "+numero" (o número) encontrado (normalmente es el contador)
    const walker2 = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    const re2 = includePlus ? /(\+)\s*\d+/ : /\d+(?!.*\d)/;
    const candidates = [];
    while ((node = walker2.nextNode())) {
      const t = node.nodeValue;
      if (!t || !re2.test(t)) continue;
      candidates.push(node);
    }
    if (candidates.length) {
      const last = candidates[candidates.length - 1];
      last.nodeValue = includePlus ? last.nodeValue.replace(re2, `+${value}`) : last.nodeValue.replace(re2, `${value}`);
      root.dataset.hpDownloadsApplied = '1';
    }
  };

  const init = () => {
    document.querySelectorAll('[data-hp-hero27]').forEach(applyToOne);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
